import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-20" }
const _hoisted_3 = { class: "d-flex gap-3 flex-wrap align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-plus" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Toutes les mandatures", -1)
const _hoisted_6 = ["value"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("button", { type: "submit" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-search-interface-symbol" })
], -1)
const _hoisted_8 = { class: "card-body p-25" }
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = { class: "table text-nowrap" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Mandature"),
    /*#__PURE__*/_createElementVNode("th", null, "Organe"),
    /*#__PURE__*/_createElementVNode("th", null, "Postes & Membres"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Actions")
  ])
], -1)
const _hoisted_12 = { class: "badge bg-primary" }
const _hoisted_13 = { class: "fw-bold" }
const _hoisted_14 = { class: "list-unstyled mb-0" }
const _hoisted_15 = {
  key: 0,
  class: "text-muted ms-2"
}
const _hoisted_16 = { class: "mt-1" }
const _hoisted_17 = {
  key: 0,
  class: "text-success"
}
const _hoisted_18 = {
  key: 1,
  class: "text-danger fst-italic"
}
const _hoisted_19 = { class: "text-center" }
const _hoisted_20 = { class: "dropdown" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-sm btn-outline-primary dropdown-toggle",
  "data-bs-toggle": "dropdown"
}, " Actions ", -1)
const _hoisted_22 = { class: "dropdown-menu" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { key: 0 }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "4",
  class: "text-center py-5 text-muted"
}, "Aucune assignation trouvée", -1)
const _hoisted_26 = [
  _hoisted_25
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/ajouter-assignation",
          class: "btn btn-success text-white"
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _createTextVNode(" Ajouter ")
          ]),
          _: 1
        }),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.mandatureFilter) = $event)),
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.loadData && _ctx.loadData(...args))),
          class: "form-select",
          style: {"width":"auto"}
        }, [
          _hoisted_5,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mandatures, (m) => {
            return (_openBlock(), _createElementBlock("option", {
              key: m.id,
              value: m.id
            }, _toDisplayString(m.libelle), 9, _hoisted_6))
          }), 128))
        ], 544), [
          [_vModelSelect, _ctx.mandatureFilter]
        ])
      ]),
      _createElementVNode("form", {
        onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.loadData && _ctx.loadData(...args)), ["prevent"])),
        class: "search-box position-relative"
      }, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchTerm) = $event)),
          onKeyup: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.loadData && _ctx.loadData(...args)), ["enter"])),
          placeholder: "Rechercher organe, poste, membre...",
          class: "form-control"
        }, null, 544), [
          [_vModelText, _ctx.searchTerm]
        ]),
        _hoisted_7
      ], 32)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("table", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedData, (group) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: `${group.mandatureId}-${group.organeId}`
              }, [
                _createElementVNode("td", null, [
                  _createElementVNode("span", _hoisted_12, _toDisplayString(group.mandatureLibelle), 1)
                ]),
                _createElementVNode("td", _hoisted_13, _toDisplayString(group.organeNom), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("ul", _hoisted_14, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.postes, (p) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: p.id,
                        class: "mb-3 pb-2 border-bottom"
                      }, [
                        _createElementVNode("strong", null, _toDisplayString(p.numeroOrdre) + " - " + _toDisplayString(p.nomPoste), 1),
                        (p.arrondissement)
                          ? (_openBlock(), _createElementBlock("small", _hoisted_15, "(" + _toDisplayString(p.arrondissement.libelle) + ")", 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_16, [
                          (p.membre)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(p.membre.nom) + " " + _toDisplayString(p.membre.prenom), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_18, "Aucun membre assigné"))
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("td", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("ul", _hoisted_22, [
                      _createElementVNode("li", null, [
                        _createVNode(_component_router_link, {
                          to: { name: 'modifierAssignation', params: { organeId: group.organeId, mandatureId: group.mandatureId } },
                          class: "dropdown-item"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Modifier ")
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _withModifiers(($event: any) => (_ctx.supprimerGroupe(group)), ["prevent"]),
                          class: "dropdown-item text-danger"
                        }, " Supprimer tout ", 8, _hoisted_23)
                      ])
                    ])
                  ])
                ])
              ]))
            }), 128)),
            (_ctx.groupedData.length === 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_24, _hoisted_26))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createVNode(_component_PaginationComponent, {
        page: _ctx.page,
        totalPages: _ctx.totalPages,
        totalElements: _ctx.totalElements,
        limit: _ctx.limit,
        onPaginate: _ctx.handlePaginate
      }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
    ])
  ]))
}